import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { convertToLocalCurrency } from "../../../utils/currency";

import { getCampaignById } from "../../../redux/slices/campaignSlice";

import BackButton from "../../../components/common/BackButton";
import { Container, Details } from "./ViewCampaignStyles";

const ViewCampaign = () => {
  const dispatch = useDispatch();
  const { campaignId } = useParams();

  const { campaign } = useSelector((state) => state.campaign);

  useEffect(() => {
    dispatch(getCampaignById(campaignId));
  }, [dispatch, campaignId]);
  if (!campaign) {
    return <div> </div>;
  }

  return (
    <Container>
      <div className="heading">
        <div className="texts">
          <h1>{campaign.campaignName || "N/A"}</h1>
          <p>View your team’s trades and transactions.</p>
        </div>

        <div className="link-buttons">
          <BackButton></BackButton>
          <Link className="add-campaign" to="/create-campaign">
            + Create Campaign
          </Link>
        </div>
      </div>

      <h4>Basic details</h4>
      <Details>
        <div className="wrapper">
          <label>Campaign name</label>
          <p>{campaign.campaignName || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
          <label>Campaign url</label>
          <a
            className="url"
            href={campaign.campaignUrl || "N/A"}
            rel="noreferrer"
            target="_blank"
          >
            {campaign.campaignUrl || "N/A"}
          </a>
        </div>
      </Details>
      <hr />

      <h4>Figures</h4>
      <Details>
        <div className="wrapper">
          <label>Budget range</label>
          <p>{convertToLocalCurrency(campaign.campaignBudget) || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
          <label>Age range</label>
          <p>{campaign.ageRange || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
          <label>Flow</label>
          <p>{campaign.flow || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
          <label>Campaign clicks</label>
          <p>{campaign.reach || "0"}</p>
        </div>

        <hr />
        <div className="wrapper">
          <label>Conversions</label>
          <p>{campaign.acquistion || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
          <label>Conversion rate</label>
          <p>{`${campaign.conversionRate}%` || "0"}</p>
        </div>
        <hr />
        <div className="wrapper">
          <label>Cost per acquisition(CPA)</label>
          <p>{campaign.costPerUser || "0"}</p>
        </div>
      </Details>
      <hr />

      <h4>Objective and location</h4>
      <Details>
        <div className="wrapper">
          <label>Campaign objective</label>
          <p>{campaign.campaignObjective || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
          <label>Carrier</label>
          <p>{campaign.carrier || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
          <label>Geo</label>
          <p>{campaign.location || "N/A"}</p>
        </div>
      </Details>
      <hr />

      <h4>Preferences</h4>
      <Details>
        <div className="wrapper">
          <label>Gender</label>
          <p>{campaign.gender || "N/A"}</p>
        </div>
        <hr />

        <div className="wrapper">
          <label>Interest</label>
          <p>{campaign.interest ? campaign.interest.join(", ") : "N/A"}</p>
        </div>
      </Details>
      <hr />

      <h4>Image</h4>
      <Details>
        {campaign.photoUrl && campaign.photoUrl[0] ? (
          <img src={campaign.photoUrl[0].url} alt="campaign-img" />
        ) : (
          <p>No image available</p>
        )}
      </Details>
    </Container>
  );
};

export default ViewCampaign;
